import styled from 'styled-components';
import React from 'react';
import { IconArrowDown, screenXxsMax, screenSmMax, spacer16, screenMdMin, } from '@spotify-internal/encore-web';
import { DELAYS, fadeInAnimation, IconNumberFill, withAnimationContext, } from '../../../ui';
import { MaskAnimation, ShowOnHoverClassName, } from '../../Animations/MaskAnimation/MaskAnimation';
import { JumpLinkResponsiveEncoreType } from '../../../Module/JumpLinkHero/JumpLinkHeroModule/JumpLinkResponsiveEncoreType';
const JumpDownArrow = styled(IconArrowDown) `
  @media (max-width: ${screenSmMax}) {
    align-self: center;
    padding-left: 16px;
  }
  @media (max-width: ${screenXxsMax}) {
    align-self: flex-end;
  }
`;
export const JumpLinkContainer = styled.div `
  display: flex;
  position: relative;
  padding: 17px 16px 16px;
  flex-direction: column;
  height: ${({ height }) => `${height}px`};

  @media (max-width: ${screenSmMax}) {
    height: auto;
    svg {
      box-sizing: unset !important;
      opacity: 1 !important;
      justify-self: flex-end;
    }
  }

  @media (max-width: ${screenXxsMax}) {
    flex-wrap: wrap;
  }
`;
const Headline = withAnimationContext(styled(JumpLinkResponsiveEncoreType).attrs({
    paddingBottom: '1em',
    variantXlDesktop: 'alto',
    variantLgDesktop: 'alto',
    variantMdDesktop: 'alto',
    variantDesktop: 'canon',
    variantMobile: 'celloCanon',
    variantSmMobile: 'canon',
}) `
    align-self: center;
    padding-bottom: 16px;
    line-height: normal;
    width: 100%;
    @media (min-width: ${screenMdMin}) {
      height: ${({ tallestHeadline }) => `${tallestHeadline}px`};
    }

    @media (max-width: 991px) {
      display: flex;
      flex-wrap: nowrap;

      h2 {
        width: 100%;
      }
      padding-bottom: 0px;
    }
    @media (max-width: ${screenXxsMax}) {
      flex-wrap: wrap;
    }
  `);
const ContentWrapper = styled.div `
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;

  @media (max-width: ${screenSmMax}) {
    flex-direction: row;
    wrap: nowrap;
    width: 100%;
  }
`;
const NumberAndTitle = styled.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  @media (max-width: ${screenSmMax}) {
    flex-direction: row;
  }
  @media (max-width: ${screenXxsMax}) {
    flex-direction: column;
  }
`;
const EyeBrowWrapper = withAnimationContext(styled.div `
  ${fadeInAnimation(DELAYS.FIRST)};
  padding-right: 16px;
  @media (max-width: 991px) {
  }
  @media (max-width: 479px) {
    width: 100%;
  }
`);
const EyeBrowNumber = styled.div `
  padding-bottom: ${spacer16};
  @media (max-width: ${screenSmMax}) {
    padding-bottom: 0px;
  }

  @media (max-width: ${screenXxsMax}) {
    padding-bottom: 16px;
  }
`;
export const JumpLink = React.forwardRef(({ module, useCustomLinkTitle, customLinkTitle = '', moduleFieldForTitle = 'headline', jumpLinkNumber, backgroundColor = '#FFFFFF', textColor = '#000000', hoverBackground, eyebrowOrHeadline = false, headline = '', eyebrowText, link, supertext = '', height = 0, tallestHeadline = 0, }, ref) => {
    const getHeadline = () => {
        if (eyebrowOrHeadline) {
            if (eyebrowText) {
                return eyebrowText;
            }
            else if (supertext) {
                return supertext;
            }
            return '';
        }
        if (headline) {
            return headline;
        }
        return '';
    };
    const getModuleHeadline = () => moduleFieldForTitle === 'headline'
        ? module === null || module === void 0 ? void 0 : module.headline
        : (module === null || module === void 0 ? void 0 : module.eyebrowText) || (module === null || module === void 0 ? void 0 : module.supertext);
    const moduleHeadline = useCustomLinkTitle
        ? customLinkTitle
        : getModuleHeadline();
    const href = module ? `#${`${module === null || module === void 0 ? void 0 : module.id}-${module === null || module === void 0 ? void 0 : module.contentType}`}` : link;
    return (React.createElement("a", { href: href, style: { textDecoration: 'none' } },
        React.createElement(MaskAnimation, { backgroundColor: backgroundColor, maskColor: hoverBackground, textColor: textColor, maskTextColor: backgroundColor },
            React.createElement(JumpLinkContainer, { height: height, ref: ref, className: "jl" },
                React.createElement(ContentWrapper, null,
                    React.createElement(NumberAndTitle, null,
                        jumpLinkNumber && (React.createElement(EyeBrowWrapper, null, jumpLinkNumber && (React.createElement(EyeBrowNumber, null,
                            React.createElement(IconNumberFill, { number: jumpLinkNumber, size: 24 }))))),
                        React.createElement(Headline, { className: "jl-headline", tallestHeadline: tallestHeadline }, module ? moduleHeadline : getHeadline())),
                    React.createElement(JumpDownArrow, { className: ShowOnHoverClassName }))))));
});
